export default function baseFloor(THREE,scene){
    const shadowMaterial = new THREE.ShadowMaterial({
        opacity: 0.25
    })

    const floor = new THREE.Mesh(
        new THREE.PlaneGeometry(10, 10),
        shadowMaterial
    )

    floor.rotation.x = -Math.PI / 2
    floor.position.y = 0
    floor.receiveShadow = true

    // scene.add(floor)
}

